import React from 'react';
import { useTranslation } from 'react-i18next';

interface DateSeparatorProps {
  date: Date;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  const { t } = useTranslation();
  
  const getDateLabel = (date: Date): string => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    // Reset time parts for comparison
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
    
    if (dateOnly.getTime() === todayOnly.getTime()) {
      return t('today');
    } else if (dateOnly.getTime() === yesterdayOnly.getTime()) {
      return t('yesterday');
    } else {
      // Format as DD/MM/YYYY or localized format
      return date.toLocaleDateString('es-ES', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric' 
      });
    }
  };
  
  return (
    <div className="flex items-center justify-center my-4">
      <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-lg text-xs font-medium shadow-sm">
        {getDateLabel(date)}
      </div>
    </div>
  );
};

export default DateSeparator;
